import produce from 'immer';
import {
    FETCH_RETURNED_ORDER_SUCCESS,
    RESET_RETURNED_ORDER
} from '../constants';

const defaultOrder = null;
const initialState = {
    order: defaultOrder,
    orders: { data: null }
};

export const returns = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case FETCH_RETURNED_ORDER_SUCCESS:
            state.order = payload;
            break;

        case RESET_RETURNED_ORDER:
            state.order = defaultOrder;
            break;

        // skip default
    }
}, initialState);
